//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useEffect,
  useContext,
  Fragment,
  useCallback,
} from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton
} from '@material-ui/core';
import * as moment from "moment";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { toastCss } from "assets/styleJS/global";
import { parseISO } from "date-fns";
import { useHistory } from "react-router";

// custom pages
import Table from "components/Table/Table";
import ManageSignatureAccountsAPI from "apis/manageSignatureAccounts/manageSignatureAccounts";
import AuditAPI from "apis/audit/audit";
import Context from "context/context";
import searchIcon from "assets/img/Search_Icon.png";
import { Styles } from "./styles";
import useDebounce from "helpers/useDebounce";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";
import Loader from "components/Loader/Loader";
import { ImportDataHeader } from "./Headers/headers";
import { exporDatatHeaders } from "./Headers/headers";

import { CSVLink } from 'react-csv';

// material-ui
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import Badge from "@material-ui/core/Badge";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import CircularProgress from "@material-ui/core/CircularProgress";
//import { MenuItem } from '@material-ui/core'


// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { blockInvalidChar } from "helpers/blockInvalidChar";
import HistoryIcon from "@material-ui/icons/History";
import { pointsFormat } from "helpers/dataFormat";
import editIcon from 'assets/img/editIcon.png';
import { is } from "date-fns/locale";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import CloseIcon from "@material-ui/icons/Close";
const Papa = require("papaparse/papaparse.min.js");

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
        background: "#ededed",
      },
    },
  },
})(TextField);

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#2F7CBD",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#2F7CBD",
      border: "6px solid #2F7CBD",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid gray`,
    backgroundColor: "gray",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default function ShiptoDetails() {
  const {
    getAPI,
    searchAPI,
    updateAPI,
    courtesyPointsCalculation,
    bulkSignatureUnEnroll,
    exportAPI,
    updateprivilegeAPI,
    filterAPI,
    updatemomentum
  } = ManageSignatureAccountsAPI();

  const { getCustomAuditAPI } = AuditAPI();
  const history = useHistory();

  const { state, dispatch } = useContext(Context);
  const classes = Styles();
  const [showPeriodDropdown, setShowPeriodDropdown] = useState(false);
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const [minimalDate, setMinimalDate] = useState(180);
  const [isLoading, setIsLoading] = useState(false);

  const [pointsUpdateObj, setPointsUpdateObj] = useState({
    open: false,
    amount: 0,
    count: 0,
    courtesyPoints: 0,
    points: 0,
    isConfirm: false
  });

  const [updateObj, setUpdateObj] = useState({
    clearSearch: false,
    index: 0,
    obj: {},
    modal: false,
    signatureStartDate: moment(new Date()).format("YYYY-MM-DD"),
    signatureEndDate: moment(new Date()).format("YYYY-MM-DD"),
    type: "",
    payementmethod: "",
    period: "",
  });

  const [updateLoading, setUpdateLoading] = useState(false);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [exportHeaders, setExportHeaders] = useState([]);
  const [exportFileName, setExportFileName] = useState("");

  const [fileName, setFileName] = useState("");

  // Common State Object
  const [states, setstates] = useState({
    clearSearch: false,
    historyDialog: false,
    historyLoader: false,
    data: [],
    status: "",
    filter: false,
  });

  const [filterCard, setFilterCard] = useState(false);

  const [dormantDialog, setDormantDialog] = useState({
    open: false,
    obj: {},
    index: null
  });

  // Momentum confirmation dialog
  const [momentumDialog, setMomentumDialog] = useState({
    open: false,
    obj: {},
    index: null,
    checked: false,
  });

  const [editObj, setEditObj] = useState({

    customer_account_number: '',
    privilege_code: '',
    id: ''

  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  let searchBounceValues = useDebounce(() => {
    return searchValue === '' ? '' : searchValue;
  });

  const { clearSearch } = states;
  const { t, i18n } = useTranslation();

  let selectedColumns = ImportDataHeader.map((header) => header.label);

  let tableHeading = [
    "Member ID",
    "Billto",
    "Shipto",
    "Shipto Name",
    "Signature Status",
    'Payment Plan',
    'Trial Period',
    "Dormant Status",
    "Earning Status",
    "Momentum",
    "",
    "History",
  ];

  const getSignatureStatus = (d) => {
    if (!d?.signature_flag) {
      return "Not Active";
    }
    if (d?.privilege_code === "ST2") {
      return "Active";
    }
    return d?.signature_end_date ? "Cancelling" : "Active";
  };

  const handlePagination = (value) => {
    setOffset(value);
  };

  useEffect(() => {
    if (!clearSearch) {
      if (searchBounceValues && searchBounceValues.length > 0) {
        handleSearch();
      } else if (states?.filter) {
        handleFilter();
      }
      else {
        handleGet();
      }
    }
    else {
      setStates({ clearSearch: false });
    }
  }, [searchBounceValues, offset, states?.filter]);

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "MANAGE SIGNATURE ACCOUNTS"],
    });
  }, []);

  // Get data API
  async function handleGet() {
    try {
      setLoading(true);
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setMinimalDate(res?.minimaldate)
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  // Search data API
  async function handleSearch() {
    try {
      setLoading(true);
      let values;
      values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setMinimalDate(res?.minimaldate)
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  // Filter data API
  async function handleFilter() {
    try {
      if (!states?.status) return;

      setLoading(true);
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
        ...(states?.status && { status: states.status }),
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await filterAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setMinimalDate(res?.minimaldate);
        setFilterCard(false);
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
      setLoading(false);
      dispatch({ type: "SET_LOADING", payload: false });
    }
  }

  const handlePaymentMethodChange = (e) => {
    const selectedPaymentMethod = e.target.value;

    setUpdateObj({
      ...updateObj,
      payementmethod: selectedPaymentMethod,
      period: "",
    });

    if (selectedPaymentMethod === "ST2") {
      setShowPeriodDropdown(true);
    } else {
      setShowPeriodDropdown(false);
    }
  };

  const handlePeriodChange = (e) => {
    setUpdateObj({
      ...updateObj,
      period: e.target.value,
    });
  };

  // Update signature API
  const handleUpdateSignature = async () => {
    toast.dismiss();
    try {
      setUpdateLoading(true);
      let values = {};

      values = {
        id: updateObj?.obj?._id,
        type: updateObj?.type,
        payementmethod: updateObj?.payementmethod,
        period: updateObj?.period
      };

      function addFixedTime(dateString, fixedTime = '15:11:11') {
        return `${dateString} ${fixedTime}`;
      }

      if (updateObj?.type === "MOVE-TO-SIGNATURE") {
        values = { ...values, date: addFixedTime(updateObj?.signatureStartDate) };
      } else {
        values = { ...values, date: addFixedTime(updateObj?.signatureEndDate) };
      }

      let res = await updateAPI(values);

      if (res && res?.type === "SUCCESS") {
        let msg = "";

        if (updateObj?.type === "MOVE-TO-SIGNATURE") {
          msg = "Account moved to Signature Successfully";
        }

        if (updateObj?.type === "MOVE-TO-NONSIGNATURE") {
          msg = "Account moved to NON-Signature Successfully";
        }

        toast.success(msg, { tostId: "signature-update-success" });

        setUpdateObj({
          index: 0,
          obj: {},
          modal: false,
          signatureStartDate: moment(new Date()).format("YYYY-MM-DD"),
          signatureEndDate: moment(new Date()).format("YYYY-MM-DD"),
          type: "",
        });

        if (offset === 1) {
          handleGet();
        } else {
          setOffset(1);
        }
      }

      setUpdateLoading(false);
    } catch (e) {
      console.log({ e });
    }
  };

  const handleUpdateprivilege = async (id) => {
    toast.dismiss();
    try {

      let values = {};

      values = {
        id: id,
        customer_account_number: editObj.customer_account_number,
        privilege_code: editObj.privilege_code,
        period: editObj.period
      };

      let res = await updateprivilegeAPI(values);

      if (res && res?.type === "SUCCESS") {
        setEditObj({})

        if (offset === 1) {
          handleGet();
        } else {
          setOffset(1);
        }
      }

      setUpdateLoading(false);
      return res;
    } catch (e) {
      console.log({ e });
    }
  };

  // Update Momentum flag
  const handleUpdateMomentum = async () => {
    try {
      setUpdateLoading(true);

      const values = {
        shipto: momentumDialog?.obj?.customer_account_number,
        loyaltyID: momentumDialog?.obj?.loyalty_id,
        momentum_flag: momentumDialog?.checked,
        id:momentumDialog?.obj?.signature_audit_id,
      };

      let res = await updatemomentum(values);

      if (res && res?.type === "SUCCESS") {
        setData((prevData) =>
          prevData.map((item, index) =>
            index === momentumDialog?.index
              ? {
                  ...item,
                  momentum_flag: momentumDialog?.checked,
                }
              : item
          )
        );

        toast.success(
          momentumDialog?.checked
            ? "Momentum flag enabled successfully."
            : "Momentum flag disabled successfully."
        );

        setMomentumDialog({
          open: false,
          obj: {},
          index: null,
          checked: false,
        });
      } else {
        toast.error("Failed to update Momentum flag.");
         setMomentumDialog({
          open: false,
          obj: {},
          index: null,
          checked: false,
        });
      }
    } catch (e) {
      console.log({ e });
      toast.error("Something went wrong while updating Momentum flag.");
       setMomentumDialog({
          open: false,
          obj: {},
          index: null,
          checked: false,
        });
    } finally {
      setUpdateLoading(false);
       setMomentumDialog({
          open: false,
          obj: {},
          index: null,
          checked: false,
        });
    }
  };

  // Get signature history
  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        feature: "manageSignatureAccounts",
      };

      let res = await getCustomAuditAPI(values);

      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleGetCalculatedCourtesyPoints = async () => {
    try {
      setUpdateLoading(true);

      let values;

      values = {
        startDate: updateObj?.signatureStartDate,
        customerAccount: updateObj?.obj?.customer_account_number
      };

      let res = await courtesyPointsCalculation(values);

      setUpdateLoading(false);

      if (res) {
        setPointsUpdateObj({
          ...pointsUpdateObj,
          open: true,
          isConfirm: false,
          amount: pointsFormat(res.amount || 0, 'en'),
          count: pointsFormat(res.count || 0, 'en'),
          points: pointsFormat(res.points || 0, 'en'),
          courtesyPoints: pointsFormat(res.courtesyPoints || 0, 'en'),
          totalPoints: pointsFormat(res.courtesyPoints + res.points || 0, 'en')
        })
      } else {
        handleUpdateSignature();
      }
    } catch (e) {
      console.log({ e });
    }
  }

const handleExport = async () => {
  let values = {};

  if (searchValue) {
    values.searchValue = searchValue;
  }

  if (states?.status) {
    values.status = states.status;
  }

  dispatch({ type: "SET_LOADING", payload: true });
  setIsLoading(true);

  let res = await exportAPI(values);

  if (res && res?.type === "ERROR") {
    dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });

    setStates({
      pLoading: false,
      eLoading: false,
      errorDialog: true,
      errorCount: res?.count,
    });
  }

  if (res && res.data) {
    dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });

    setExportData(
      res.data.map(obj => {
        return {
          ...obj,

          signature_flag: getSignatureStatus(obj),

          privilege_code: obj.is_unlocked
            ? "Unlocked"
            : obj?.privilege_code === "ST0"
              ? "Monthly"
              : obj?.privilege_code === "ST1"
                ? "Yearly"
                : obj?.privilege_code === "ST2"
                  ? "Trial"
                  : "-",

          dormant_account_flag: obj.dormant_account_flag
            ? "YES"
            : "NO",

          mktcls_modified: obj.mktcls_modified
            ? "NO"
            : "YES",

          trial_period: obj.trial_period
            ? `${obj.trial_period} Months`
            : "-",

          // Momentum is already converted by backend
          momentum_flag: obj.momentum_flag || "No",
        };
      })
    );

    setExportFileName("SIGNATURE_ACCOUNTS");
    setExportHeaders(exporDatatHeaders);

    dispatch({ type: "SET_LOADING", payload: false });
    setIsLoading(false);

    setStates({
      response: true,
      pLoading: false,
      eLoading: false,
    });

    if (res.data.length === 0) {
      toast.success(t("No Data Found"), {
        toastId: "no-report-date",
      });
      return false;
    }

    return true;
  }
};

  const handleExportimport = async () => {
    setExportData([])
    setExportHeaders(ImportDataHeader)
    setExportFileName('Signature_Offboarding')
    return true;
  };

  function selectedColumnFun() {
    {
      setStates({ data: [] });

      let data = [];

      ImportDataHeader.map((header, i) => {
        if (selectedColumns?.includes(header.label)) {
          data = [...data, header.key];
          return;
        }
      });

      setStates({ selectedFields: data });
    }
  }

  function handleChange(event) {
    selectedColumnFun();
    importCSV(event.target.files[0]);
  }

  function importCSV(csvFile) {
    Papa.parse(csvFile, {
      complete: updateData,
      header: true,
    });

    setFileName(csvFile.name)
  }

  function updateData(result) {
    var data = result.data;
    preparePayload(data);
  }

  function preparePayload(data) {
    const payload = [];

    for (let value of data) {
      if (
        JSON.stringify(selectedColumns) === JSON.stringify(Object.keys(value))
      ) {
        let achData = {};

        ImportDataHeader.forEach((header) => {
          achData[header.key] = value[header.label];
        });

        if (!moment(achData.signature_end_date, 'MM/DD/YYYY').isValid()) {
          console.log("Invalid date detected, clearing filename");
          setFileName("");

          return toast.error(
            `Please Enter valid dateformat for ${achData?.customer_account_number} shipto`,
            {
              ...toastCss,
              autoClose: 5000,
            }
          )
        }

        if (
          moment(
            achData.signature_end_date,
            'MM/DD/YYYY'
          ).isBefore(moment(), 'day')
        ) {
          setFileName("");

          return toast.error(
            `Deactivation Date should be today or a future date.`,
            {
              ...toastCss,
              autoClose: 5000,
            }
          )
        }

        payload.push(achData);
      }
    };

    if (payload.length === 0) {
      setFileName("");

      toast.error(
        `*${t("Please import csv file in given order")}`,
        {
          ...toastCss,
          autoClose: 5000,
        }
      );

      document.getElementById("demo").value = null;

      return;
    }

    setStates({ data: payload });
  }

  const handleUploadCSV = async () => {
    try {
      if (states.data.length == 0) {
        return toast.error(
          `*${t("Please import csv file in given order")}`,
          {
            ...toastCss,
            autoClose: 5000,
          }
        );
      }

      let values = {
        data: states.data
      };

      setUpdateLoading(true);

      let res = await bulkSignatureUnEnroll(values);

      setUpdateLoading(false);

      if (res.type === "success" && res.valid) {
        let headers = [
          ...ImportDataHeader,
          {
            label: "Status",
            key: "status"
          }
        ]

        return history.push("/dashboard/signature-status", {
          data: {
            successCount: res.successCount,
            successData: res.successData,
            ImportDataHeader,
            headers
          },
          type: i18n.language == 'fr' ? res.french_message : res.message
        });
      } else if (res.type === "success" && res.invalid) {
        let headers = [
          ...ImportDataHeader,
          {
            label: "Status",
            key: "status",
          },
          {
            label: "Reason",
            key: "reason",
          }
        ];

        return history.push("/dashboard/signature-status", {
          obj: {
            data: {
              invalidData: res.invalidData,
              successData: res.successData,
            },
            uploadedCount: res.uploadedCount,
            invalidCount: res.invalidCount,
            successCount: res.successCount,
            ImportDataHeader,
            headers
          }
        });
      }
    } catch (err) {
      setStates({ loading: false });
      console.log(err);
    }
  };

  // Function to get the larger date
  const getLargerDate = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);

    return momentDate1.isAfter(momentDate2) ? momentDate1 : momentDate2;
  };

  console.log(updateObj?.payementmethod, "updateObj?.payementmethod")

  return (
    <Fragment>
      <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
      
<CssTextField
  id="enterPassword"
  placeholder={t("Search for Billto or Shipto")}
  onKeyDown={blockInvalidChar}
  type="number"  
  onWheel={(e) => e.target.blur()}
  variant="outlined"
  autoComplete="off"
  className={classes.searchInput}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        {searchValue.length > 0 ? (
          <CloseOutlinedIcon
            className={classes.searchInputIcon}
            onClick={() => {
              setStates({ clearSearch: true });
              setSearchValue("");

              if (offset === 1) {
                handleGet();
              } else {
                setOffset(1);
              }
            }}
          />
        ) : (
          <img
            src={searchIcon}
            alt=""
            width="20px"
            className={classes.searchInputIcon}
          />
        )}
      </InputAdornment>
    ),
  }}
  value={searchValue}
  onChange={(e) => {
    e.target.value.replace(/\s+/g, "").length === 0
      ? setSearchValue("")
      : setSearchValue(e.target.value);

    if (e.target.value.length === 0) {
      handleGet();
    }
  }}
  onClick={() => {
    setOffset(1);
  }}
/>


        <div>
          <button
            className={classes.exportBtn}
            style={{ marginRight: 10 }}
            onClick={() => {
              setFilterCard(!filterCard);

              if (!states.filter) {
                setStates({ status: '' });
              }
            }}
          >
            {states.filter ? (
              <Badge badgeContent={1} color="secondary">
                <span style={{ paddingRight: 4 }}>{t('Filter')}</span>
              </Badge>
            ) : (
              t('Filter')
            )}
          </button>

          <button
            className={classes.exportBtn}
            onClick={async () => {
              setStates({
                response: false,
                data: [],
                eLoading: true
              });

              let res = await handleExport();

              if (res) {
                let data = [];
                document.getElementById("csv").click();
              }
            }}
            disabled={states.eLoading || states.pLoading}
          >
            {states.eLoading ? (
              'Loading...'
            ) : (
              ` Export `
            )}
          </button>
        </div>
      </Grid>

      {filterCard && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            border: '1px solid #ddd',
            borderRadius: 12,
            padding: '10px 25px',
            marginTop: 15,
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              width: '55%',
              borderRight: '1px solid #ddd',
              paddingRight: 25,
              marginRight: 25,
            }}
          >
            <TextField
              id="signatureStatusFilter"
              label={t('Status')}
              select
              fullWidth
              type="text"
              value={states?.status}
              onChange={(e) => {
                setStates({ status: e.target.value });
              }}
            >
              <MenuItem value="Active">{t('Active')}</MenuItem>
              <MenuItem value="Cancelling">{t('Cancelling')}</MenuItem>
            </TextField>
          </div>

          <Button
            variant="contained"
            color="primary"
            style={{
              fontSize: 14,
              borderRadius: 8,
              padding: '10px 35px'
            }}
            onClick={() => {
              if (!states.status) {
                toast.error('Please select a status', {
                  toastId: 'filter-empty',
                });

                return;
              }

              setSearchValue('');
              setStates({ filter: true });
              setOffset(1);
              setCount(0);
              handleFilter();
            }}
          >
            {t('Apply')}
          </Button>

          {states.filter && (
            <Button
              variant="outlined"
              style={{
                fontSize: 14,
                borderRadius: 8,
                padding: '10px 35px',
                marginLeft: 15
              }}
              onClick={() => {
                setStates({
                  filter: false,
                  status: ''
                });

                setFilterCard(false);

                if (offset === 1) {
                  handleGet();
                } else {
                  setOffset(1);
                }
              }}
            >
              {t('Reset')}
            </Button>
          )}
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        {!loading ? (
          <Table
            headings={tableHeading.map((i) => {
              return <div key={t(i)}>{t(i)}</div>;
            })}
            data={
              data &&
              data.length > 0 &&
              data.map((d, i) => [
                d?.loyalty_id,
                d?.customer_billto_account_number,
                d?.customer_account_number,
                d?.Customer_Account?.customer_name,

                d?.signature_flag ?
                  (
                    d?.privilege_code === "ST2" ? (
                      <span className={classes.greenBtn}>{"Active "}</span>
                    ) : d?.signature_end_date ? (
                      <span className={classes.redBtn}>{"Cancelling"}</span>
                    ) : (
                      <span className={classes.greenBtn}>{"Active "}</span>
                    )
                  ) : (
                    <span
                      className={classes.blackBtn}
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      Not Active
                    </span>
                  ),

                editObj.customer_account_number === d?.customer_account_number ? (

                  <TextField
                    label={t("Payment Plan")}
                    style={{ width: "100%" }}
                    select
                    value={editObj?.privilege_code}
                    onChange={(e) => {
                      setEditObj({
                        ...editObj,
                        privilege_code: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value="ST0">Monthly</MenuItem>
                    <MenuItem value="ST1">Yearly</MenuItem>
                    <MenuItem value="ST2">Trial</MenuItem>
                  </TextField>

                ) : d?.Loyalty_Subscription_Mapping?.some(
                  (m) => m.plan === "Thrive Unlocked" && m.is_active === true
                ) ? (
                  <span>Unlocked</span>
                ) : d?.privilege_code === "ST0" ? (
                  <span>Monthly</span>
                ) : d?.privilege_code === "ST1" ? (
                  <span>Yearly</span>
                ) : d?.privilege_code === "ST2" ? (
                  <span>Trial</span>
                ) : (
                  <span>-</span>
                ),

                editObj.customer_account_number === d?.customer_account_number ? (
                  editObj?.privilege_code === "ST2" ? (
                    <TextField
                      select
                      label={t("Trial Period")}
                      style={{ width: "100%" }}
                      value={editObj?.period || 'Select Period'}
                      onChange={(e) =>
                        setEditObj({
                          ...editObj,
                          period: e.target.value,
                        })
                      }
                    >
                      <MenuItem value="3">{t("3 Months")}</MenuItem>
                      <MenuItem value="4">{t("4 Months")}</MenuItem>
                      <MenuItem value="5">{t("5 Months")}</MenuItem>
                      <MenuItem value="6">{t("6 Months")}</MenuItem>
                    </TextField>
                  ) : (
                    <span>-</span>
                  )
                ) : d?.trial_period && d?.privilege_code === "ST2" ? (
                  <span>{`${d.trial_period} Months`}</span>
                ) : (
                  <span>-</span>
                ),

                d?.Loyalty_Account?.dormant_account_flag ? (
                  <span>Active</span>
                ) : (
                  <span>{"-"}</span>
                ),

                d?.Loyalty_Account?.mktcls_modified ? (
                  <span>No</span>
                ) : (
                  <span>Yes</span>
                ),

                // Momentum Flag
                d?.momentum_flag_enable==1 ? (
  <IOSSwitch
    checked={Boolean(d?.momentum_flag)}
    onChange={(e) => {
      const checked = e.target.checked;

      setMomentumDialog({
        open: true,
        obj: d,
        index: i,
        checked: checked,
      });
    }}
    name="momentum"
  />
) : (
  <div style={{ textAlign: "center", width: "50%" }}>
    -
  </div>
),

                d?.signature_flag ? [
                  editObj.customer_account_number == d?.customer_account_number ? (
                    <React.Fragment>
                      <CheckCircleOutlineIcon
                        style={{
                          cursor: 'pointer',
                          color: 'green',
                          margin: '0px 5px',
                          fontSize: 35,
                        }}
                        onClick={async () => {
                          if (
                            editObj.privilege_code === d?.privilege_code &&
                            d?.privilege_code !== "ST2"
                          ) {
                            toast.error(
                              "Please change at least one field before updating."
                            );
                            return;
                          }

                          if (
                            editObj.privilege_code === "ST2" &&
                            !editObj.period
                          ) {
                            toast.error(
                              "Please select the trial period."
                            );
                            return;
                          }

                          const res = await handleUpdateprivilege(d?._id);

                          if (res && res?.type === "SUCCESS") {
                            toast.success(
                              "Payment Plan updated successfully!"
                            );
                          } else {
                            toast.error("No changes detected.");
                          }
                        }}
                      />

                      <HighlightOffIcon
                        style={{
                          cursor: 'pointer',
                          color: 'red',
                          margin: '0px 5px',
                          fontSize: 35,
                        }}
                        onClick={() => setEditObj({})}
                      />
                    </React.Fragment>
                  ) : (
                    d?.Signature_Unenrollment_Request?.some(
                      req => req.status === "Inprogress"
                    ) &&
                    d?.signature_flag === true ||
                    d?.Loyalty_Subscription_Mapping?.some(
                      (m) =>
                        m.plan === "Thrive Unlocked" &&
                        m.is_active === true
                    ) ? (
                      '-'
                    ) : (
                      <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setEditObj({
                            ...editObj,
                            customer_account_number:
                              d?.customer_account_number,
                            privilege_code: d?.privilege_code,
                          });
                        }}
                      >
                        <img
                          src={editIcon}
                          alt=''
                          width='20'
                        />
                      </div>
                    )
                  )
                ] : '-',

                state?.userInfo?.auditAccess && (

                  <RemoveRedEyeIcon
                    key={i}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push(
                        "/dashboard/update-plan-history",
                        {
                          Id: d?._id,
                          shipto: d?.customer_account_number,
                        }
                      );
                    }}
                  />

                ),
              ])
            }
            offset={offset}
            count={
              (count / 10) % 1 == 0
                ? Math.floor(count / 10)
                : Math.floor(count / 10 + 1)
            }
            handlePagination={handlePagination}
          />
        ) : (
          <div
            style={{
              height: "25vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>{t("Loading...")}</h2>
          </div>
        )}
      </div>

      {/* Signature handling dialog */}
      <Dialog
        maxWidth={"md"}
        aria-labelledby="simple-dialog-title"
        open={updateObj.modal}
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div className={classes.dialogParentDiv}>
          {updateObj?.type === "MOVE-TO-SIGNATURE" &&
            <div className={classes.parentText}>
              {t("Signature Enrollment")}
            </div>
          }

          {updateObj?.type === "MOVE-TO-NONSIGNATURE" &&
            <div className={classes.parentText}>
              {t("Confirm Signature Cancellation")}
            </div>
          }

          <div className={classes.parentText2}>
            &nbsp;&nbsp;&nbsp;

            {updateObj?.type === "MOVE-TO-SIGNATURE" && (
              <Fragment>
                <span>
                  {t(
                    `Select the Member's Signature Start Date and Payment Plan`
                  )}
                </span>
                <br />
              </Fragment>
            )}

            {updateObj?.type === "MOVE-TO-NONSIGNATURE" && (
              <span>
                {t(
                  "Schedule or adjust a signature end date up to a day before the set cancellation date."
                )}
              </span>
            )}
          </div>

          <br />

          <Fragment>
            {updateObj?.type === "MOVE-TO-SIGNATURE" && (
              <Fragment>
                <div className={classes.subParentBody}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      inputVariant="outlined"
                      format={"MM/dd/yyyy"}
                      margin="normal"
                      id="deactive-date"
                      className={classes.dateInput}
                      maxDate={moment()}
                      minDate={
                        updateObj?.obj?.signature_end_date
                          ? moment(
                              updateObj?.obj?.signature_end_date
                            ).add(1, 'days')
                          : getLargerDate(
                              moment().subtract(
                                minimalDate,
                                'days'
                              ),
                              moment(
                                updateObj?.obj?.loyalty_start_date
                              )
                            )
                      }
                      value={parseISO(
                        updateObj?.signatureStartDate
                      )}
                      onChange={(date) => {
                        let d = moment(date).format(
                          "YYYY-MM-DD"
                        );

                        setUpdateObj({
                          ...updateObj,
                          signatureStartDate: d,
                        });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      autoOk
                    />
                  </MuiPickersUtilsProvider>
                </div>

                <TextField
                  className={classes.paymentdrop}
                  label={t("Payment Plan")}
                  select
                  value={updateObj.payementmethod}
                  onChange={handlePaymentMethodChange}
                  fullWidth
                >
                  <MenuItem value="ST0">
                    {t("Monthly")}
                  </MenuItem>

                  <MenuItem value="ST1">
                    {t("Yearly")}
                  </MenuItem>

                  <MenuItem value="ST2">
                    {t("Trial")}
                  </MenuItem>
                </TextField>

                {showPeriodDropdown && (
                  <FormControl
                    style={{
                      marginTop: "10px",
                      display: "block"
                    }}
                    className={classes.paymentdrop}
                  >
                    <InputLabel>
                      {t('Trial Period')}
                    </InputLabel>

                    <Select
                      value={updateObj.period}
                      onChange={handlePeriodChange}
                      label={t('Trial Period')}
                      fullWidth
                    >
                      <MenuItem value="3">
                        {t("3 Months")}
                      </MenuItem>

                      <MenuItem value="4">
                        {t("4 Months")}
                      </MenuItem>

                      <MenuItem value="5">
                        {t("5 Months")}
                      </MenuItem>

                      <MenuItem value="6">
                        {t("6 Months")}
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
              </Fragment>
            )}

            {updateObj?.type === "MOVE-TO-NONSIGNATURE" && (
              <Fragment>
                <div className={classes.subParentHeader}>
                  {updateObj?.obj?.signature_end_date
                    ? t("Edit the Signature End Date")
                    : t("Signature End Date")}

                  &nbsp;

                  <span style={{ color: "red" }}>
                    *
                  </span>
                </div>

                <div className={classes.subParentBody}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      inputVariant="outlined"
                      format={"MM/dd/yyyy"}
                      margin="normal"
                      id="deactive-date"
                      className={classes.dateInput}
                      minDate={
                        updateObj?.obj?.privilege_code === 'ST2' &&
                        updateObj?.obj?.signature_end_date
                          ? new Date()
                          : new Date(
                              updateObj?.obj?.loyalty_start_date ||
                              Date.now()
                            )
                      }
                      maxDate={
                        updateObj?.obj?.privilege_code === 'ST2' &&
                        updateObj?.obj?.signature_end_date
                          ? new Date(
                              updateObj?.obj?.signature_end_date
                            )
                          : undefined
                      }
                      value={
                        updateObj?.signatureEndDate
                          ? new Date(
                              updateObj.signatureEndDate
                            )
                          : updateObj?.obj?.signature_end_date
                            ? new Date(
                                updateObj.obj.signature_end_date
                              )
                            : null
                      }
                      onChange={(date) => {
                        if (!date) return;

                        const d = moment(date).format(
                          "YYYY-MM-DD"
                        );

                        setUpdateObj({
                          ...updateObj,
                          signatureEndDate: d,
                        });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      autoOk
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </Fragment>
            )}
          </Fragment>

          {(updateObj?.obj?.signature_end_date &&
            updateObj?.obj?.signature_flag &&
            updateObj?.obj?.privilege_code !== 'ST2') && (
              <div
                style={{
                  textDecoration: 'underline',
                  color: 'blue',
                  textAlign: 'center',
                  cursor: 'pointer',
                  fontSize: 17,
                }}
                onClick={async () => {
                  try {
                    let res = await updateAPI({
                      type: "CONTINUE-TO-SIGNATURE",
                      id: updateObj?.obj?._id,
                    });

                    if (
                      res &&
                      res?.type === "SUCCESS"
                    ) {
                      toast.success(
                        "Account moved to Signature Successfully",
                        {
                          tostId:
                            "signature-update-success"
                        }
                      );

                      setUpdateObj({
                        ...updateObj,
                        modal: false
                      });

                      handleGet();
                    }
                  } catch {
                    toast.error(
                      "Something went wrong",
                      {
                        tostId:
                          "signature-update-failed"
                      }
                    );
                  }
                }}
              >
                Remove Signature End Date
              </div>
            )}

          <br />

          {updateObj?.type === "MOVE-TO-SIGNATURE" &&
            <span className={classes.parentText2Note}>
              {t(
                "Note: Signature benefits will be awarded according to the start date that is selected."
              )}
            </span>
          }

          <br />
          <br />

          <Grid container spacing={0}>
            {!updateLoading ? (
              <Fragment>
                <Grid item xs={6}>
                  <Button
                    className={classes.cancelBtn}
                    disabled={loading}
                    onClick={() => {
                      setData([
                        ...data.slice(
                          0,
                          updateObj?.index
                        ),
                        {
                          ...data[
                            updateObj?.index
                          ],
                          checked:
                            !data[
                              updateObj?.index
                            ]?.checked,
                        },
                        ...data.slice(
                          updateObj?.index + 1
                        ),
                      ]);

                      setUpdateObj({
                        index: 0,
                        obj: {},
                        modal: false,
                        signatureStartDate:
                          moment(new Date()).format(
                            "YYYY-MM-DD"
                          ),
                        signatureEndDate:
                          moment(new Date()).format(
                            "YYYY-MM-DD"
                          ),
                        type: "",
                      });
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                </Grid>

                <Grid
                  item
                  xs={6}
                  className={classes.proceedBtnGrid}
                >
                  <Button
                    className={classes.proceedBtn}
                    disabled={loading}
                    onClick={() => {
                      if (
                        updateObj?.type ===
                        "MOVE-TO-SIGNATURE"
                      ) {

                        if (
                          moment(
                            updateObj?.signatureStartDate
                          ).isBefore(
                            moment().subtract(
                              minimalDate,
                              'days'
                            ).format(
                              "YYYY-MM-DD"
                            )
                          )
                        ) {
                          toast.dismiss();

                          return toast.error(
                            "Date should not be before minimal date",
                            {
                              toastId:
                                "invalid-signature-startdate-error",
                            }
                          );
                        }

                        if (
                          moment(
                            updateObj?.signatureStartDate
                          ).isAfter(
                            moment().format(
                              "YYYY-MM-DD"
                            )
                          )
                        ) {
                          toast.dismiss();

                          return toast.error(
                            "Invalid Start Date",
                            {
                              toastId:
                                "invalid-signature-startdate-error",
                            }
                          );
                        }

                        if (
                          moment(
                            updateObj?.signatureStartDate
                          ).isBefore(
                            moment(
                              updateObj?.obj
                                ?.loyalty_start_date
                            ).format(
                              "YYYY-MM-DD"
                            )
                          )
                        ) {
                          toast.dismiss();

                          return toast.error(
                            "Date should not be before minimal date",
                            {
                              toastId:
                                "invalid-signature-startdate-error",
                            }
                          );
                        }

                        if (
                          updateObj?.obj
                            ?.signature_end_date &&
                          moment(
                            updateObj?.signatureStartDate
                          ).isBefore(
                            moment(
                              updateObj?.obj
                                ?.signature_end_date
                            )
                              .add(1, 'days')
                              .format(
                                "YYYY-MM-DD"
                              )
                          )
                        ) {
                          toast.dismiss();

                          return toast.error(
                            "Date should not be before minimal date",
                            {
                              toastId:
                                "invalid-signature-startdate-error",
                            }
                          );
                        }

                        if (
                          updateObj?.signatureStartDate ===
                          "Invalid date"
                        ) {
                          toast.dismiss();

                          return toast.error(
                            "Invalid Start Date",
                            {
                              toastId:
                                "invalid-signature-startdate-error",
                            }
                          );
                        }

                        if (
                          updateObj?.payementmethod ===
                          'ST2' &&
                          !updateObj?.period
                        ) {
                          toast.error(
                            "Please select the trial period."
                          );

                          return;
                        }

                        const selectedStartDate =
                          moment(
                            updateObj?.signatureStartDate
                          );

                        const trialPeriod =
                          updateObj?.period;

                        if (
                          updateObj?.payementmethod ===
                          'ST2'
                        ) {
                          const expectedEndDate =
                            selectedStartDate
                              .clone()
                              .add(
                                trialPeriod,
                                'months'
                              );

                          if (
                            expectedEndDate.isBefore(
                              moment(),
                              'day'
                            )
                          ) {
                            toast.error(
                              `The selected start date is not allowed because the trial would have already ended. Please select a start date that allows the full ${trialPeriod}-month trial.`
                            );

                            return;
                          }
                        }

                        if (
                          !updateObj?.payementmethod
                        ) {
                          toast.dismiss();

                          return toast.error(
                            "Please Select The Payment Plan",
                            {
                              toastId:
                                "Please Select The Payment Plan",
                            }
                          );
                        }

                        if (
                          moment(
                            updateObj.signatureStartDate
                          ).isBefore(
                            moment().format(
                              'YYYY-MM-DD'
                            )
                          )
                        ) {
                          return handleGetCalculatedCourtesyPoints()
                        }
                      }

                      if (
                        updateObj?.type ===
                        "MOVE-TO-NONSIGNATURE"
                      ) {
                        if (
                          moment(
                            updateObj?.signatureEndDate
                          ).isBefore(
                            moment(new Date()).format(
                              "YYYY-MM-DD"
                            )
                          )
                        ) {
                          toast.dismiss();

                          return toast.error(
                            "Date should not be before minimal date",
                            {
                              toastId:
                                "invalid-signature-startdate-error",
                            }
                          );
                        }
                      }

                      handleUpdateSignature();
                    }}
                  >
                    {t("Update")}
                  </Button>
                </Grid>
              </Fragment>
            ) : (
              <Grid
                item
                xs={12}
                className={
                  classes.updateDialogLoader
                }
              >
                <CircularProgress />
              </Grid>
            )}
          </Grid>
        </div>
      </Dialog>

    {/* Momentum confirmation dialog */}
<Dialog
  open={momentumDialog.open}
  onClose={() => {
    if (!updateLoading) {
      setMomentumDialog({
        open: false,
        obj: {},
        index: null,
        checked: false,
      });
    }
  }}
  maxWidth="sm"
  fullWidth
  scroll="paper"
  PaperProps={{
    style: {
      borderRadius: 16,
      overflow: "hidden",
      boxShadow: "0px 12px 40px rgba(0, 0, 0, 0.20)",
      fontFamily: "Segoe-ui",
      maxHeight: "90vh",
    },
  }}
>
  {/* Header */}
  <div
    style={{
      background:
        "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
      padding: "20px 24px",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexShrink: 0,
    }}
  >
    <div>
      <div
        style={{
          fontSize: "22px",
          fontWeight: 600,
          marginBottom: "4px",
        }}
      >
        Momentum Flag
      </div>

      <div
        style={{
          fontSize: "13px",
          opacity: 0.9,
        }}
      >
        Update Momentum Flag status
      </div>
    </div>

    <IconButton
      onClick={() => {
        if (!updateLoading) {
          setMomentumDialog({
            open: false,
            obj: {},
            index: null,
            checked: false,
          });
        }
      }}
      disabled={updateLoading}
      style={{
        color: "#fff",
      }}
    >
      <CloseIcon />
    </IconButton>
  </div>

  {/* Scrollable Body */}
  <div
    style={{
      padding: "26px 28px 24px",
      background: "#fff",
      overflowY: "auto",
      maxHeight: "calc(90vh - 100px)",
      boxSizing: "border-box",
    }}
  >
    {/* Current Status Card */}
    <div
      style={{
        background: "#f5f9ff",
        border: "1px solid #dbeafe",
        borderRadius: 12,
        padding: "16px",
        marginBottom: "20px",
      }}
    >
      <div
        style={{
          fontSize: "12px",
          color: "#64748b",
          marginBottom: "6px",
          fontWeight: 500,
        }}
      >
        CURRENT STATUS
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <div
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor:
              momentumDialog.obj?.momentum_flag === 1 ||
              momentumDialog.obj?.momentum_flag === true
                ? "#22c55e"
                : "#f71111",
          }}
        />

        <span
          style={{
            fontSize: "17px",
            fontWeight: 600,
            color:
              momentumDialog.obj?.momentum_flag === 1 ||
              momentumDialog.obj?.momentum_flag === true
                ? "#15803d"
                : "#f71111",
          }}
        >
          {momentumDialog.obj?.momentum_flag === 1 ||
          momentumDialog.obj?.momentum_flag === true
            ? "ON"
            : "OFF"}
        </span>
      </div>
    </div>

    {/* Customer Details */}
    <div
      style={{
        marginBottom: "20px",
      }}
    >
      <div
        style={{
          fontSize: "14px",
          fontWeight: 600,
          color: "#334155",
          marginBottom: "12px",
        }}
      >
        Customer Details
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
        }}
      >
        <div
          style={{
            background: "#f8fafc",
            borderRadius: 10,
            padding: "12px 14px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              color: "#64748b",
              marginBottom: "4px",
            }}
          >
            Customer Account
          </div>

          <div
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#1e293b",
              wordBreak: "break-word",
            }}
          >
            {momentumDialog.obj?.customer_account_number || "-"}
          </div>
        </div>

        <div
          style={{
            background: "#f8fafc",
            borderRadius: 10,
            padding: "12px 14px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              color: "#64748b",
              marginBottom: "4px",
            }}
          >
            Loyalty ID
          </div>

          <div
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#1e293b",
              wordBreak: "break-word",
            }}
          >
            {momentumDialog.obj?.loyalty_id || "-"}
          </div>
        </div>
      </div>
    </div>

    {/* Confirmation Message */}
    <div
      style={{
        background: momentumDialog.checked
          ? "#fff7ed"
          : "#f0fdf4",
        border: momentumDialog.checked
          ? "1px solid #fed7aa"
          : "1px solid #bbf7d0",
        borderRadius: 12,
        padding: "16px",
        marginBottom: "24px",
      }}
    >
      <div
        style={{
          fontSize: "14px",
          lineHeight: 1.6,
          color: "#334155",
        }}
      >
        Are you sure you want to{" "}
        <strong>
          {momentumDialog.checked ? "turn ON" : "turn OFF"}
        </strong>{" "}
        the Momentum Flag for this customer?
      </div>
    </div>

    {/* Buttons */}
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "12px",
        paddingTop: "4px",
      }}
    >
      <Button
        variant="outlined"
        onClick={() => {
          if (!updateLoading) {
            setMomentumDialog({
              open: false,
              obj: {},
              index: null,
              checked: false,
            });
          }
        }}
        disabled={updateLoading}
        style={{
          borderRadius: 8,
          textTransform: "none",
          fontWeight: 600,
          padding: "9px 20px",
          borderColor: "#cbd5e1",
          color: "#475569",
        }}
      >
        Cancel
      </Button>

      <Button
        variant="contained"
        onClick={async () => {
          await handleUpdateMomentum();
        }}
        disabled={updateLoading}
        style={{
          borderRadius: 8,
          textTransform: "none",
          fontWeight: 600,
          padding: "9px 20px",
          minWidth: 100,
          background: momentumDialog.checked
            ? "#1976d2"
            : "#dc2626",
        }}
      >
        {updateLoading ? (
          <CircularProgress
            size={20}
            style={{
              color: "#fff",
            }}
          />
        ) : momentumDialog.checked ? (
          "Turn ON"
        ) : (
          "Turn OFF"
        )}
      </Button>
    </div>
  </div>
</Dialog>

      {/* Dormant dialog */}
      <Dialog
        open={dormantDialog.open}
        onClose={() =>
          setDormantDialog({
            open: false,
            obj: {},
            index: null
          })
        }
        maxWidth="sm"
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div style={{ padding: 20 }}>
          <h2 style={{ marginBottom: 10 }}>
            <span>
              {t(
                `Proceed with Reactivation and Signature Enrollment`
              )}
            </span>
          </h2>

          <p>
            This customer is currently in a dormant status.
            Would you like to reactivate the customer and enroll
            them into the Signature subscription plan?
            Click 'Yes' to proceed.
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 20
            }}
          >
            <Button
              onClick={() => {
                setDormantDialog({
                  open: false,
                  obj: {},
                  index: null
                });
              }}
              variant="outlined"
              style={{ marginRight: 10 }}
            >
              No
            </Button>

            <Button
              onClick={() => {
                setDormantDialog({
                  open: false,
                  obj: {},
                  index: null
                });

                setUpdateObj({
                  ...updateObj,
                  index: dormantDialog.index,
                  obj: dormantDialog.obj,
                  modal: true,
                  type: "MOVE-TO-SIGNATURE",
                });
              }}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </div>
        </div>
      </Dialog>

      <Dialog
        aria-labelledby="simple-dialog-title"
        open={pointsUpdateObj?.open}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={'md'}
      >
        <div
          className={classes.dialogParentDiv}
          style={{
            margin: 20,
            background: "#ddd"
          }}
        >
          <div
            className={classes.parentText}
            style={{ textAlign: 'center' }}
          >
            {`${t("Confirm")} Additional Signature Points`}
          </div>

          <div className={classes.tdiv}>
            <div className={classes.parentText3}>
              {`Shipto ID : ${updateObj?.obj?.customer_account_number}`}
            </div>

            <table style={{ margin: 20 }}>
              <tr>
                <td className={classes.td}>
                  Total Transaction Count
                </td>

                <td className={classes.td}>
                  <strong>
                    {pointsUpdateObj?.count}
                  </strong>
                </td>
              </tr>

              <tr>
                <td className={classes.td}>
                  Total Eligible Purchase Amt
                </td>

                <td className={classes.td}>
                  <strong>
                    ${pointsUpdateObj?.amount}
                  </strong>
                </td>
              </tr>

              <tr>
                <td className={classes.td}>
                  Total Points Already Awarded
                </td>

                <td className={classes.td}>
                  <strong>
                    {pointsUpdateObj?.points}
                  </strong>
                </td>
              </tr>

              <tr>
                <td className={classes.td}>
                  Total Additional Points
                </td>

                <td className={classes.td}>
                  <strong>
                    {pointsUpdateObj?.courtesyPoints}
                  </strong>
                </td>
              </tr>
            </table>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              margin: "20px 20px 0px 20px"
            }}
          >
            {!updateLoading ? (
              <>
                <Button
                  className={classes.cancelBtn}
                  style={{
                    fontSize: 12,
                    borderWidth: 1,
                    borderRadius: 5
                  }}
                  onClick={() =>
                    setPointsUpdateObj({
                      ...pointsUpdateObj,
                      open: false,
                      isConfirm: false
                    })
                  }
                >
                  Cancel
                </Button>

                <Button
                  className={classes.proceedBtn}
                  style={{
                    fontSize: 12,
                    borderRadius: 5
                  }}
                  onClick={async () => {
                    await handleUpdateSignature();

                    setPointsUpdateObj({
                      ...pointsUpdateObj,
                      open: false
                    })
                  }}
                >
                  Proceed
                </Button>
              </>
            ) : (
              <Grid
                item
                xs={12}
                className={
                  classes.updateDialogLoader
                }
              >
                <CircularProgress />
              </Grid>
            )}
          </div>
        </div>
      </Dialog>

      {/* Audit Logs Dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width:
                states?.historyData?.length > 0
                  ? "100%"
                  : 300,
            }}
          >
            History{" "}

            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({
                    historyDialog: false,
                    historyData: []
                  });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Setting",
                "Description",
                "Reason",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(
                        d?.created_at
                      ).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}`
                    : "",

                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by
                        .charAt(0)
                        .toUpperCase() +
                      d?.altered_by
                        .slice(1)
                        .toLowerCase()
                      : "-"
                  }`,

                  d?.column_name,

                  `"${!d?.old_value
                    ? "not set"
                    : moment(
                        d?.old_value,
                        [
                          "YYYY-MM-DD",
                          "YYYY-MM-DD HH:mm:ss",
                          "ddd MMM DD YYYY HH:mm:ss [GMT]Z"
                        ],
                        true
                      ).isValid()
                        ? moment(
                            d?.old_value
                          ).format(
                            "MMM DD YYYY"
                          )
                        : d?.old_value
                  }" changed to "${!d?.new_value
                    ? "not set"
                    : moment(
                        d?.new_value,
                        [
                          "YYYY-MM-DD",
                          "YYYY-MM-DD HH:mm:ss",
                          "ddd MMM DD YYYY HH:mm:ss [GMT]Z"
                        ],
                        true
                      ).isValid()
                        ? moment(
                            d?.new_value
                          ).format(
                            "MMM DD YYYY"
                          )
                        : d?.new_value
                  }"`,

                  d?.reason,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader
                Loading={historyLoader}
                top={"15%"}
              />
            </div>
          )}
        </div>
      </Dialog>

      <Dialog
        aria-labelledby="simple-dialog-title"
        open={bulkUploadOpen}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={'md'}
      >
        <div
          className={classes.dialogParentDiv}
          style={{
            margin: 20,
            background: "#ddd"
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              textAlign: "center",
              marginTop: 10,
              marginBottom: 10,
              marginLeft: 40,
            }}
          >
            <h2>Signature Offboarding</h2>

            <input
              id="demo"
              type="file"
              accept=".csv"
              placeholder={t("import csv")}
              style={{
                color: "transparent",
                width: "45%"
              }}
              onChange={(e) => {
                if (!state?.userInfo?.editAction) {
                  toast.error(
                    state.userInfo?.editAccess
                  );
                  return;
                }

                if (state?.userInfo?.editAction) {
                  handleChange(e);
                  return;
                }
                else {
                  toast.error(
                    state.userInfo?.editAccess
                  );
                  return;
                }
              }}
              disabled={
                !state?.userInfo?.editAction
              }
            />

            {fileName && <div>{fileName}</div>}

            <div
              style={{
                textDecoration: "underline",
                color: "blue",
                cursor: "pointer"
              }}
              onClick={async () => {
                let res =
                  await handleExportimport();

                if (res) {
                  document
                    .getElementById("csv")
                    .click();
                }
              }}
            >
              click here to download sample file
            </div>
          </Grid>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              margin: "20px 20px 0px 20px"
            }}
          >
            {!updateLoading ? (
              <>
                <Button
                  className={classes.cancelBtn}
                  style={{
                    fontSize: 12,
                    borderWidth: 1,
                    borderRadius: 5
                  }}
                  onClick={() => {
                    setBulkUploadOpen(false);
                    setFileName("");
                  }}
                >
                  Cancel
                </Button>

                <Button
                  className={classes.proceedBtn}
                  style={{
                    fontSize: 12,
                    borderRadius: 5
                  }}
                  onClick={async () => {
                    await handleUploadCSV()
                  }}
                >
                  Proceed
                </Button>
              </>
            ) :
              <Grid
                item
                xs={12}
                className={
                  classes.updateDialogLoader
                }
              >
                <CircularProgress />
              </Grid>
            }
          </div>
        </div>
      </Dialog>

      <CSVLink
        id='csv'
        data={exportData}
        headers={exportHeaders}
        filename={
          exportFileName +
          ' ' +
          moment(new Date()).format(
            'MM-DD-YYYY,h:mm A'
          ) +
          '.csv'
        }
        className={classes.CSVlink}
      />
    </Fragment>
  );
}